/**
 * @generated SignedSource<<02f7fbcc658c5f6abc0df6cce50f08ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionSecondChanceOffer_viewer$data = {
  readonly isMultiItemCart: boolean | null;
  readonly " $fragmentType": "PdpSharedAuctionSecondChanceOffer_viewer";
};
export type PdpSharedAuctionSecondChanceOffer_viewer$key = {
  readonly " $data"?: PdpSharedAuctionSecondChanceOffer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionSecondChanceOffer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionSecondChanceOffer_viewer",
  "selections": [
    {
      "alias": "isMultiItemCart",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiItemCart"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiItemCart\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9b5359d3a2fc4d86063d05a22f4a7d35";

export default node;
